{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Selecione um item",
  "tableResizer": "Redimensionador"
}
